import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.prueflauf-bild-entfernen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufBildEntfernenEffects {

    PrueflaufBildEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFLAUF_BILD_ENTFERNEN),
        mergeMap((x: ac.PostPrueflaufBildEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPrueflaufBildEntfernen(x.prueflaufBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostPrueflaufBildEntfernenErfolgreichAction(result, x.prueflaufBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPrueflaufBildEntfernenFehlerAction(error, x.prueflaufBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufCommandService);
        }
        return this.service;
    }
}
